export default __webpack_public_path__ + "static/media/logo_planb.50562aab.png";